<div class="bz-alert" *ngIf="alerts.length > 0">
  <div *ngFor="let alert of alerts">
    <alert [type]="alert.type.toLowerCase()" dismissible="true" [dismissOnTimeout]="alert.timeout">
      <i *ngIf="alert.type.toLowerCase() === 'completed'" class="bz-icon bz-icon-boolean"></i>
      <i *ngIf="alert.type.toLowerCase() === 'warning'" class="bz-icon bz-icon-warning-outline"></i>
      <i *ngIf="alert.type.toLowerCase() === 'error'" class="bz-icon bz-icon-error"></i>
      <span>{{ alert.message | translate }}</span>
    </alert>
  </div>
</div>
